import React, { useEffect, useState } from 'react'
import { YellowButton } from '../../components/YellowButton'
import { Link, useNavigate } from 'react-router-dom'
import { BorderedPageLayout } from '../BorderedPageLayout'
import { AnalysisIcon, QRScan} from '../../icons'
import { PatientItem } from '../../components/ListItems/PatientItem'
import { AnalysisItem } from '../../components/ListItems/AnalysisItem'
import { CartItem } from '../../components/ListItems/CartItem'
import styles from '../Profile/profile.module.scss'
import { OrderCard } from '../../components/OrderCard'
import Skeleton from 'react-loading-skeleton'
import { useAppDispatch, useAppSelector } from '../../app/hooks'
import { getProfile, getByHash, getDiscount } from '../../features/profile/profileSlice'
import { getGreeting } from '../../utils/getGreeting'
import { getAllOrders, incrementOrdersPart, resetOrders } from '../../features/orders/ordersSlice'
import { usePagination } from '../../hooks/usePagination'
import { handleOrderInfoModal, handleQRScannerModal } from '../../features/modals/modalsSlice'
import { normalizeDate } from '../../utils/normalizeDate'
import { setPatient } from '../../features/order/orderSlice'


import useTheme from '../../hooks/useAppColor'

export const QRInfoPage = () => {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const getTheme = useTheme()


    
    const { all_orders, loadings, can_next, part } = useAppSelector(state => state.orders)
    const profile = useAppSelector(state => state.profile)
    const {id, first_name, last_name, subname} = useAppSelector(state => state.agent)
  

    const [loadOrders, loadMore] = usePagination(
        () => {
            dispatch(getAllOrders({ part }
            ))
        },
        () => { dispatch(incrementOrdersPart()) },
        {
            part,
            can_more: can_next,
            items: all_orders,
            loading: loadings.all_orders_pagination
        }
    )

    const handleToOrdering = () => {
        dispatch(setPatient({
            id: Number(profile.data.crm_id),
            first_name: profile.data.first_name,
            last_name: profile.data.last_name
        }))
        navigate("/order/category")
    }

    const handleOpenQrReader = () => {
        dispatch(handleQRScannerModal())
    }

    useEffect(loadOrders, [part])

    useEffect(() => {
        return () => {
            dispatch(resetOrders())
        }
    }, [])

    useEffect(() => {
            const searchParams = new URLSearchParams(window.location.search);
                const data: any = searchParams.get('discount')
               
                if(data !== null){
                    
                    dispatch(getByHash(data))
                    
                    const newUrl = `${window.location.pathname}`;
                    window.history.replaceState({}, document.title, newUrl);
                }

          }, [window.location.search]);

    
    useEffect(() => {
        if(id !== 0){
            
            dispatch(getDiscount({
                docID: id   
            }))

        }
    },[id])


    return (
        <BorderedPageLayout
            contentClassName={"f-column gap-50"}>
            <div className="f-column gap-25">
                <div className="d-f jc-between">
                    <div onClick={() => navigate("/")} className="textButton fz-l">Закрыть</div>
                    <div className='f-025'></div>
                </div>
                <div className="f-row-betw gap-10">
                    <div onClick={handleOpenQrReader} className={`big-btn whiteBorderedBlock ${getTheme("", "app-bg-dark")} f-c-col gap-15 w-100p`}>
                        <QRScan />
                        <p className={`${getTheme("c-black", "c-white")} txt-center fw-5 fz-m`}>Отсканировать QR-код</p>
                    </div>
                </div>
                <div className="f-row-betw gap-10">
                    <div className={`big-btn whiteBorderedBlock ${getTheme("", "app-bg-dark")} f-c-col gap-15 w-100p`}>
                        <h2 className={`title ${getTheme("c-black", "c-white")} txt-center `}>{last_name} <br />{first_name} {subname}</h2>
                    </div>
                </div>
            </div>
        </BorderedPageLayout>
    )
}
